var map = {
	"./en/1/nav2.png": 71597,
	"./fi/1/nav2.png": 43083,
	"./in/1/nav2.png": 14505,
	"./th/1/nav2.png": 90278,
	"./tw/1/nav2.png": 82975,
	"./zh/1/nav2.png": 32932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45425;